// make invite text editable
export function inviteText() {
    // button to set focus within changeable text
    const changeInviteText = document.querySelector(
        "#change-invite-text",
    ) as HTMLInputElement;
    if (changeInviteText) {
        changeInviteText.addEventListener("click", (event) => {
            event.preventDefault();
            const container = document.querySelector(
                ".invite-text-container.active",
            );
            if (container) {
                const invText = container.querySelector(
                    ".invite-text",
                ) as HTMLInputElement;
                if (invText) {
                    invText.focus();
                }
            }
        });
    }

    // set correct value on page load
    const invText = document.querySelector(
        '[data-form-id="invite-text"]',
    ) as HTMLInputElement;
    if (invText) {
        const container = document.querySelector(
            ".invite-text-container.active",
        );
        if (container) {
            const text = container.querySelector(".invite-text");
            invText.value = text?.innerHTML ?? "";
        }
    }

    // set correct value on event
    const allInvText = document.querySelectorAll(".invite-text");
    if (allInvText.length > 0) {
        allInvText.forEach((invText) => {
            invText.addEventListener("input", (event) => {
                const target = event.target as HTMLElement;
                const invText = document.querySelector(
                    '[data-form-id="invite-text"]',
                ) as HTMLInputElement;

                let userInput = target.innerHTML;

                // erlaubte HTML-Tags
                const allowedTags = ["ul", "li", "strong", "p", "br", "h1"];

                // regex zum entfernen alle nicht erlaubten Tags
                const regex = new RegExp("<\/?([a-z]+)[^>]*>", "gi");

                // ersetzen nicht erlaubten Tags durch leeren String
                userInput = userInput.replace(regex, function (match, tag) {
                    return allowedTags.indexOf(tag.toLowerCase()) !== -1
                        ? match
                        : "";
                });

                invText.value = userInput;
            });
        });
    }
}
